export default {
  data() {
    return {
      company_full: this.$store.state.company_full,
    };
  },

  methods: {
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb

      return (usedMb / totalMb) * 100;
    },
  },
};
